import { EventStatus } from "@/types/enums/event";
import type { EventDetail } from "@/types/event";

const isNonCompleteChecklistCandidate = (event: EventDetail) =>
  event.status !== EventStatus.COMPLETED &&
  event.status !== EventStatus.CANCELLED;

export function shouldShowSidebarChecklist(
  appointment: EventDetail,
  renderedAppointments: EventDetail[],
) {
  if (renderedAppointments.length <= 1) return true;
  if (!appointment.start) return true;

  const firstNonCompleteAppointment =
    renderedAppointments.reduce<EventDetail | null>((firstEvent, event) => {
      if (!event.start || !isNonCompleteChecklistCandidate(event)) {
        return firstEvent;
      }
      if (!firstEvent?.start) return event;

      return new Date(event.start).getTime() <
        new Date(firstEvent.start).getTime()
        ? event
        : firstEvent;
    }, null);

  if (!firstNonCompleteAppointment?.start) return true;

  return (
    new Date(appointment.start).getTime() <=
    new Date(firstNonCompleteAppointment.start).getTime()
  );
}
